import { apiRequest } from '../axiosInstance';
import axiosInstance from '../axiosInstance';
import { USAGE_ENDPOINTS, buildQueryString } from '../endpoints';

const usageService = {
  getMyUsage: async () => {
    return apiRequest(() =>
      axiosInstance.get(USAGE_ENDPOINTS.MY_USAGE)
    );
  },

  getUsageSummary: async (organizationId) => {
    const queryString = buildQueryString({ organizationId });
    return apiRequest(() =>
      axiosInstance.get(`${USAGE_ENDPOINTS.SUMMARY}${queryString}`)
    );
  },

  getUsageHistory: async (orgId, months = 6) => {
    const queryString = buildQueryString({ months });
    return apiRequest(() =>
      axiosInstance.get(`${USAGE_ENDPOINTS.HISTORY(orgId)}${queryString}`)
    );
  },

  getOverages: async (orgId, year, month) => {
    const queryString = buildQueryString({ year, month });
    return apiRequest(() =>
      axiosInstance.get(`${USAGE_ENDPOINTS.OVERAGES(orgId)}${queryString}`)
    );
  },

  getAllOrganizationsUsage: async () => {
    return apiRequest(() =>
      axiosInstance.get(USAGE_ENDPOINTS.ALL_ORGANIZATIONS)
    );
  },
};

export default usageService;
